import { UtilityService } from './utility.service';
import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ApiTranslatorService } from './api-translator.service';

@Injectable({
  providedIn: 'root',
})
export class InterceptorService implements HttpInterceptor {
  constructor(
    private apiTranslatorService: ApiTranslatorService,
    private _utilityService: UtilityService,
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    let reqClone = req;
    let body = req.body;

    const token: string | null = localStorage.getItem('token');

    if (body && typeof body === 'string') {
      body = this.changeBody(body);
    }

    const isLoginRequest = req.url.includes('/api/login');

    if (token && !isLoginRequest) {
      reqClone = req.clone({
        body,
        setHeaders: {
          authorization: token,
        },
      });
    } else if (body !== req.body) {
      reqClone = req.clone({ body });
    }

    return next
      .handle(reqClone)
      .pipe(catchError((error: HttpErrorResponse) => this.manejarError(error)));
  }

  manejarError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      console.log(`Client-side error: ${error.status} ${error.error.message}`);
    } else {
      console.warn('Backend error:', error);
    }

    return throwError(() => error);
  }

  changeBody(body: string): string {
    const json = JSON.parse(body.slice(5));
    const jsonSnakeCase = this.apiTranslatorService.modelToSnakeCase(json);
    return 'json=' + JSON.stringify(jsonSnakeCase);
  }
}
